import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDGPD_INF_FIN;

export default {
  post(payload) {
    return baseApi.put(resource, payload);
  },
};
